import { Modal } from "antd";
import { Capacitor } from "@capacitor/core";
import { Filesystem, Directory, Encoding } from "@capacitor/filesystem";
import { Network } from "@capacitor/network";
import { App } from "@capacitor/app";

export const getPlatform = () => Capacitor.getPlatform();

export const writeDirectory = async (foldername) => {
	try {
		return await Filesystem.mkdir({
			path: foldername,
			directory: Directory.Data,
			recursive: true,
		});
	} catch (error) {
		throw error;
	}
};

export const readDirectory = async (foldername = "") => {
	try {
		return await Filesystem.readdir({
			path: foldername ?? "/",
			directory: Directory.Data,
		});
	} catch (error) {
		throw error;
	}
};

export const writeFile = async (file, data) => {
	try {
		return await Filesystem.writeFile({
			path: file,
			data: data,
			directory: Directory.Data,
			encoding: Encoding.UTF8,
		});
	} catch (error) {
		throw error;
	}
};

export const readFile = async (file) => {
	try {
		return await Filesystem.readFile({
			path: file,
			directory: Directory.Data,
			encoding: Encoding.UTF8,
		});
	} catch (error) {
		throw error;
	}
};

export const deleteFile = async (file) => {
	try {
		return await Filesystem.deleteFile({
			path: file,
			directory: Directory.Data,
		});
	} catch (error) {
		throw error;
	}
};

export const setFileStorage = async (
	foldername,
	filename,
	data,
	override = false,
) => {
	const file = `${foldername}/${filename}.txt`;
	try {
		const res = await Filesystem.readFile({
			path: file,
			directory: Directory.Data,
			encoding: Encoding.UTF8,
		});
		if (override) {
			let datanew = JSON.parse(res.data);
			if (Array.isArray(data)) {
				datanew.push(...data);
			} else {
				datanew.push(data);
			}
			await writeFile(file, JSON.stringify(datanew));
		} else {
			await writeFile(file, JSON.stringify(data));
		}
		return true;
	} catch (error) {
		try {
			const res = await readDirectory();
			let files = res && res.files ? res.files : [];
			let fileExist = files.find((f) => f.name === foldername);
			if (!fileExist) {
				await writeDirectory(foldername);
			}
			if (Array.isArray(data)) {
				await writeFile(file, JSON.stringify(data));
			} else {
				await writeFile(file, JSON.stringify([data]));
			}
			return true;
		} catch (err) {
			console.error("Error setting file storage:", err);
			throw err;
		}
	}
};

export const checkPermissions = async () => {
	try {
		return await Filesystem.checkPermissions();
	} catch (error) {
		throw error;
	}
};
export const requestPermissions = async (file) => {
	try {
		return await Filesystem.requestPermissions();
	} catch (error) {
		throw error;
	}
};

export const checkNetworkStatus = async () => {
	// Network.addListener("networkStatusChange", (status) => {
	// 	console.log("Network status changed", status);
	// });
	return await Network.getStatus();
};

export const useRequestPublicStoragePermissions = async () => {
	const status = await Filesystem.checkPermissions();

	if (status.publicStorage === "granted") {
		// Proceed with file operations
		console.log("File permission granted");
		// ... your file access code ...
	} else {
		// Explain why permission is needed
		Modal.info({
			title: "File Storage Permission",
			content: (
				<div>
					<p>This app needs file storage access to save your surveys.</p>
				</div>
			),
			onOk: async () => {
				const newStatus = await Filesystem.requestPermissions();

				if (newStatus.publicStorage === "granted") {
					// Proceed with file operations
					console.log("File permission granted after request");
				} else {
					Modal.info({
						title: "Permission Required",
						content: (
							<div>
								<p>File storage access is required for this app.</p>
								<p>Do you want to open app settings to grant permission?</p>
							</div>
						),
						onOk: async () => {
							// Redirect to app settings
							await App.openSettings();
						},
					});
				}
			},
		});
	}
};
